angular.module('bribac.services.showSamplesChartModal', [
    'ui.bootstrap',
    'bribac.components.sampleChartModal'
])

    .factory('showSamplesChartModal', function (
        $uibModal
    ) {
        return function (subject) {
            return $uibModal.open({
                component: 'sampleChartModal',
                resolve: {
                    subject: subject
                },
                backdrop: 'static'
            })
        }
    });
